import { ErrorLayout } from 'components';
import { DialogConfirmDelete } from 'components/dialogs';
import { useScrollToTop } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

import { useDirectories } from '../../createOrder/hooks';
import { useOrder } from '../hooks/useOrder';
import { useOrderInitialValues } from '../hooks/useOrderInitialValues';
import { OrderProvider } from '../providers/OrderProvider';
import { OrderView } from '../views/OrderView/OrderView';

export const OrderContainer = () => {
  const {
    notFound,
    order,
    brokerTimezoneOffset,
    actions,
    orderSchema,
    disabledDates,
    minEndDate,
    submitLoading,
    loadingDelete,
    isOpenDialogConfirmDelete,
    onEnableEdit,
    onDisableEdit,
    onSubmit,
    onCloseDialogConfirmDelete,
    onOpenDialogConfirmDelete,
    onDelete,
    onDownloadOrder,
  } = useOrder();

  const {
    loading: directoriesLoading,
    directories,
    schemas,
  } = useDirectories({
    orderSchema,
  });

  const initialValues = useOrderInitialValues(
    order,
    orderSchema,
    brokerTimezoneOffset,
    disabledDates
  );

  const { t } = useTranslation();

  const title =
    t('account.order.title') + (order?.number ? ` №${order.number}` : '');

  usePageTitle(title);

  useScrollToTop([]);

  if (notFound) {
    return <ErrorLayout subtitle={t('notFound.subtitle')} />;
  }

  return (
    <OrderProvider
      brokerTimezoneOffset={brokerTimezoneOffset}
      directories={directories}
      disabledDates={disabledDates}
      minEndDate={minEndDate}
      order={order}
      orderType={order?.operationType}
      schemas={schemas}
      onDelete={onOpenDialogConfirmDelete}
      onDisableEdit={onDisableEdit}
      onDownloadOrder={onDownloadOrder}
      onEnableEdit={onEnableEdit}
    >
      <OrderView
        actions={actions}
        initialValues={initialValues}
        loading={!initialValues || directoriesLoading}
        submitLoading={submitLoading}
        title={title}
        onSubmit={onSubmit}
      />

      <DialogConfirmDelete
        isOpen={isOpenDialogConfirmDelete}
        loading={loadingDelete}
        onClose={onCloseDialogConfirmDelete}
        onConfirm={onDelete}
      />
    </OrderProvider>
  );
};
